import { Link } from 'react-router-dom';
import SiteHeader from '../../components/feature/SiteHeader';
import SiteFooter from '../../components/feature/SiteFooter';
import Breadcrumb from '../../components/feature/Breadcrumb';
import SectionHeading from '../../components/feature/SectionHeading';

const valueCards = [
  {
    icon: 'ri-stack-line',
    title: '内容多元',
    desc: '聚合资讯、娱乐、科技与生活服务，多板块内容一站浏览，满足不同兴趣需求。',
  },
  {
    icon: 'ri-layout-4-line',
    title: '版面清晰',
    desc: '信息层级分明、分类清晰，图文搭配得当，让每一条内容都更易读、更易找。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '检索便捷',
    desc: '支持关键词搜索与分类、标签、时间组合筛选，帮你快速定位感兴趣的话题。',
  },
  {
    icon: 'ri-device-line',
    title: '多端友好',
    desc: '电脑与手机端自适应布局，随时随地顺畅获取信息，阅读体验始终如一。',
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1 w-full">
        {/* 头部 */}
        <section className="w-full px-4 md:px-8 pt-6 pb-8 bg-background-100 border-b border-background-200">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
            <div className="mt-5">
              <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                关于 WWW.17C.COM
              </h1>
              <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
                WWW.17C.COM 是一个专注多元内容的综合门户平台，面向广大互联网用户，聚合最新动态、热门话题与实用信息，致力于打造方便、高效且版面清晰的多样化内容展示平台。
              </p>
            </div>
          </div>
        </section>

        {/* 网站定位 */}
        <section className="w-full px-4 md:px-8 py-10">
          <div className="max-w-5xl mx-auto">
            <SectionHeading title="网站定位" icon="ri-compass-3-line" description="我们做什么，为谁而做" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {valueCards.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center text-xl mb-4">
                    <i className={item.icon} />
                  </span>
                  <h3 className="font-heading font-semibold text-base text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 联系方式 */}
        <section className="w-full px-4 md:px-8 pb-10">
          <div className="max-w-5xl mx-auto">
            <SectionHeading title="联系我们" icon="ri-customer-service-2-line" description="欢迎交流反馈（演示信息）" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <a
                href="mailto:contact@17c.com"
                className="group rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
              >
                <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center text-xl mb-4">
                  <i className="ri-mail-send-line" />
                </span>
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  电子邮箱
                </h3>
                <p className="mt-2 text-sm text-foreground-600 group-hover:text-primary-600 transition-colors">
                  contact@17c.com
                </p>
              </a>

              <a
                href="https://bjparadise.cn"
                target="_blank"
                rel="noopener noreferrer"
                className="group rounded-lg border border-background-200 bg-background-50 p-5 hover:border-accent-300 transition-colors"
              >
                <span className="w-11 h-11 rounded-md bg-accent-50 text-accent-600 flex items-center justify-center text-xl mb-4">
                  <i className="ri-weibo-line" />
                </span>
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  微博
                </h3>
                <p className="mt-2 text-sm text-foreground-600 group-hover:text-accent-600 transition-colors">
                  @17C综合门户
                </p>
              </a>

              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-xl mb-4">
                  <i className="ri-wechat-line" />
                </span>
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  微信公众号
                </h3>
                <p className="mt-2 text-sm text-foreground-600">17C资讯</p>
              </div>
            </div>
          </div>
        </section>

        {/* 使用说明与免责声明 */}
        <section className="w-full px-4 md:px-8 pb-10">
          <div className="max-w-5xl mx-auto">
            <SectionHeading title="使用说明与免责声明" icon="ri-information-line" />
            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8 space-y-5">
              <div>
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  使用说明
                </h3>
                <ul className="mt-3 space-y-2 text-sm text-foreground-600 leading-relaxed">
                  <li className="flex gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-accent-500 shrink-0" />
                    通过顶部导航或首页快捷入口，进入相应分类浏览内容。
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-accent-500 shrink-0" />
                    使用搜索框输入关键词，可结合类别与时间筛选快速定位内容。
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-accent-500 shrink-0" />
                    收藏功能基于浏览器本地存储，仅用于本地演示展示。
                  </li>
                </ul>
              </div>
              <div className="pt-5 border-t border-background-200">
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  免责声明
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  本站为综合门户主题的演示项目，站内所有文章标题、摘要、正文、图片及联系方式均为演示数据，不代表任何真实作品或机构信息。搜索、筛选与收藏均为前端演示功能，不涉及真实后台服务与账户体系，收藏状态不会真实持久化保存。如本站内容涉及版权或其他问题，请联系我们处理。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 返回首页 */}
        <section className="w-full px-4 md:px-8 pb-14">
          <div className="max-w-5xl mx-auto rounded-lg bg-primary-500 p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-background-50">
                开始探索 WWW.17C.COM
              </h2>
              <p className="mt-2 text-sm text-background-100/90">
                浏览最新资讯、热门话题与精选专题，发现你感兴趣的内容。
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-home-line" />
                返回首页
              </Link>
              <Link
                to="/special"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap"
              >
                浏览专题
              </Link>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}